import { gql } from '@apollo/client';

export default gql`
  query GetContacts {
    contact {
      Contacts {
        firstName
        lastName
        description
        phoneNumber
        jobTitle
        email
        urlSlug
        image {
          url
        }
      }
    }
  }
`;
